import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TrademarkCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/TrademarkCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(TrademarkCircleTwoTone);